module.exports = __webpack_public_path__ + "static/media/success.d29f1779.svg";